import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Stream } from '../types/stream';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import {UntypedFormGroup} from '@angular/forms';

@Component({
    selector: 'stream-creator-modal',
    templateUrl: './stream-creator-modal.component.html',
    styleUrls: ['./stream-creator-modal.component.scss']
})
export class StreamCreatorModalComponent{
    @ViewChild('streamCreatorModal', {static: false}) public streamCreatorModal: ElementRef;

    @Input()
    public stream: Stream;

    @Output()
    public closeStreamModalEmitter: EventEmitter<any> = new EventEmitter();

    @Output()
    public savedStreamEmitter: EventEmitter<Stream> = new EventEmitter();

    public streamForm: UntypedFormGroup;
    public thumbnailErrors = {
        limit: false,
        other: ''
    };

    public currentStreamThumb: any;
    public streamTypes = [];
    public selectedStreamTypeKind: any;
    public savingStreamProgress = false;
    public addressLocation: any = {};
    public enableCustomUrl = false;

    public subscriptionsObject = [];
    public validPriceRange = {
        min: 0,
        max: 10000
    };

    private modalRef: any;

    constructor(
        private modalService: NgbModal) { }

    public saveStreamUpdate(stream: any): void {
        this.savedStreamEmitter.emit(stream);
    }

    public showStreamModal(): void {
        this.modalRef = this.modalService.open(this.streamCreatorModal, { windowClass: 'stream-creator-modal', size: 'lg' });

        this.modalRef.result.then(result => {
            console.log(`Closed with:`, result);
            this.modalRef.close();
        }, reason => {
            console.log(`Dismissed`, reason);
            this.modalRef.close();
        })
        .catch(e => {
            console.log('error while closing modal: ', e);
        });
    }

    public closeStreamModal(): void {
        this.closeStreamModalEmitter.emit();
        this.modalRef.close();
    }
}
